<template>
    <router-view />
</template>

<script>
export default {
    name: 'RouteLayout'
}
</script>
